const r = {
  slate1000: "#161C22",
  slate900: "#2B343D",
  slate800: "#3F4C58",
  slate700: "#546574",
  slate600: "#758CA0",
  slate500: "#8099AE",
  slate400: "#9CB1C3",
  slate300: "#BECBD6",
  slate200: "#D8DFE5",
  slate100: "#F0F2F4",
  slate50: "#F7F9FA",
  gray1000: "#1B1C1C",
  gray900: "#323334",
  gray800: "#494A4C",
  gray700: "#616365",
  gray600: "#7B7D7F",
  gray500: "#939598",
  gray400: "#ADAFB1",
  gray300: "#C8C9CA",
  gray200: "#DDDEDE",
  gray100: "#F2F2F2",
  gray50: "#F8F8F8",
  port1000: "#301009",
  port900: "#561F16",
  port800: "#7D2C25",
  port700: "#A33B38",
  port600: "#BA4545",
  port500: "#E26C68",
  port400: "#E8948F",
  port300: "#EDBBB7",
  port200: "#F2D7D4",
  port100: "#F9EFEF",
  port50: "#FBF7F7",
  red1000: "#380606",
  red900: "#610F11",
  red800: "#881A1C",
  red700: "#B12525",
  red600: "#D33423",
  red500: "#F35C49",
  red400: "#F68C7D",
  red300: "#F6B7AE",
  red200: "#F7D5D0",
  red100: "#FBEFED",
  red50: "#FCF7F7",
  terracotta1000: "#360B02",
  terracotta900: "#5D1805",
  terracotta800: "#83250A",
  terracotta700: "#AB3312",
  terracotta600: "#DF461B",
  terracotta500: "#F95728",
  terracotta400: "#FA8A6E",
  terracotta300: "#F9B7A5",
  terracotta200: "#F9D5CB",
  terracotta100: "#FAEFEC",
  terracotta50: "#FCF7F6",
  orange1000: "#321001",
  orange900: "#581E01",
  orange800: "#7D2E04",
  orange700: "#A43D06",
  orange600: "#CD4F09",
  orange500: "#F86A0B",
  orange400: "#FE8A51",
  orange300: "#FBB797",
  orange200: "#FBD5C3",
  orange100: "#FBEFE9",
  orange50: "#FDF7F4",
  yellow1000: "#281800",
  yellow900: "#472D01",
  yellow800: "#674101",
  yellow700: "#885604",
  yellow600: "#A67103",
  yellow500: "#C68700",
  yellow400: "#E69E04",
  yellow300: "#FFB636",
  yellow200: "#FCD8A3",
  yellow100: "#FCF0DF",
  yellow50: "#FDF8F1",
  pear1000: "#102101",
  pear900: "#213C01",
  pear800: "#325603",
  pear700: "#447205",
  pear600: "#578F07",
  pear500: "#69AB0B",
  pear400: "#79C410",
  pear300: "#92E431",
  pear200: "#A7FA50",
  pear100: "#E2FCCF",
  pear50: "#F2FDEA",
  green1000: "#012306",
  green900: "#003E20",
  green800: "#015A2D",
  green700: "#037730",
  green600: "#07963F",
  green500: "#08A847",
  green400: "#10D05A",
  green300: "#38EE70",
  green200: "#8DFBA2",
  green100: "#DCFCE0",
  green50: "#EFFDF1",
  sage1000: "#002310",
  sage900: "#023E21",
  sage800: "#025A32",
  sage700: "#057644",
  sage600: "#089557",
  sage500: "#0EB169",
  sage400: "#0ECE7B",
  sage300: "#42F499",
  sage200: "#85FBB4",
  sage100: "#DBFBE5",
  sage50: "#EFFDF3",
  jade1000: "#012217",
  jade900: "#013D2C",
  jade800: "#025841",
  jade700: "#037456",
  jade600: "#03936E",
  jade500: "#08AF84",
  jade400: "#04CC9A",
  jade300: "#41F2BB",
  jade200: "#77FBCB",
  jade100: "#D8FBEC",
  jade50: "#EEFDF6",
  turquoise1000: "#01211E",
  turquoise900: "#003C37",
  turquoise800: "#01574F",
  turquoise700: "#007369",
  turquoise600: "#019184",
  turquoise500: "#03AC9E",
  turquoise400: "#00CDBC",
  turquoise300: "#32E6D4",
  turquoise200: "#59FBE9",
  turquoise100: "#D4FCF5",
  turquoise50: "#ECFDFA",
  cerulean1000: "#012026",
  cerulean900: "#043A44",
  cerulean800: "#085461",
  cerulean700: "#0E6F7F",
  cerulean600: "#128CA1",
  cerulean500: "#16A7BF",
  cerulean400: "#1DC2DE",
  cerulean300: "#4CDEFA",
  cerulean200: "#A9EBFA",
  cerulean100: "#E1F6FB",
  cerulean50: "#F1FAFC",
  blue1000: "#011D35",
  blue900: "#003460",
  blue800: "#005078",
  blue700: "#046A9B",
  blue600: "#0285C4",
  blue500: "#0095DA",
  blue400: "#45B9FF",
  blue300: "#95D1FC",
  blue200: "#C3E3FB",
  blue100: "#e9f3fb",
  blue50: "#f5f9fd",
  blurple1000: "#09015E",
  blurple900: "#19009B",
  blurple800: "#2C01D6",
  blurple700: "#4B3FFF",
  blurple600: "#5A65FF",
  blurple500: "#7589FF",
  blurple400: "#94A8FF",
  blurple300: "#B8C6FB",
  blurple200: "#D4DDFB",
  blurple100: "#EEF1FC",
  blurple50: "#F7F8FD",
  periwinkle1000: "#180057",
  periwinkle900: "#2D0090",
  periwinkle800: "#4302C8",
  periwinkle700: "#5E39FF",
  periwinkle600: "#6C5EFF",
  periwinkle500: "#8483FF",
  periwinkle400: "#9FA3FF",
  periwinkle300: "#BFC4FB",
  periwinkle200: "#D8DBFB",
  periwinkle100: "#F0F1FB",
  periwinkle50: "#F7F8FD",
  royal1000: "#1D0152",
  royal900: "#360089",
  royal800: "#4E01BF",
  royal700: "#7133FF",
  royal600: "#7C55FF",
  royal500: "#917EFF",
  royal400: "#A9A0FF",
  royal300: "#C5C1FC",
  royal200: "#DBDAFB",
  royal100: "#F1F1FB",
  royal50: "#F8F8FD",
  indigo1000: "#22014D",
  indigo900: "#3D0082",
  indigo800: "#5800B6",
  indigo700: "#7402EB",
  indigo600: "#832CFF",
  indigo500: "#9D77FE",
  indigo400: "#B39BFF",
  indigo300: "#CBBFFC",
  indigo200: "#DFD9FA",
  indigo100: "#F2F0FB",
  indigo50: "#F8F8FD",
  violet1000: "#260148",
  violet900: "#44007A",
  violet800: "#6100AB",
  violet700: "#7F00DE",
  violet600: "#9626FF",
  violet500: "#AB6FFE",
  violet400: "#BD96FF",
  violet300: "#D2BCFB",
  violet200: "#E3D7FA",
  violet100: "#F3F0FB",
  violet50: "#F9F7FD",
  purple1000: "#2B0141",
  purple900: "#4A0171",
  purple800: "#6801A1",
  purple700: "#8700D3",
  purple600: "#A627FF",
  purple500: "#B056FF",
  purple400: "#C691FF",
  purple300: "#D9B9FC",
  purple200: "#E8D5FA",
  purple100: "#F4EFFB",
  purple50: "#FAF7FC",
  magenta1000: "#320032",
  magenta900: "#570057",
  magenta800: "#7B017B",
  magenta700: "#A100A1",
  magenta600: "#CA00CA",
  magenta500: "#FF00FF",
  magenta400: "#FF61FD",
  magenta300: "#FCA6F8",
  magenta200: "#FBCCF8",
  magenta100: "#FBECFA",
  magenta50: "#FCF6FC",
  rose1000: "#380121",
  rose900: "#5F013B",
  rose800: "#870156",
  rose700: "#B00071",
  rose600: "#DC038F",
  rose500: "#F4019F",
  rose400: "#FF78BC",
  rose300: "#FCAED1",
  rose200: "#FBD0E2",
  rose100: "#FCEDF3",
  rose50: "#FCF7F9",
  ruby1000: "#3B0009",
  ruby900: "#650116",
  ruby800: "#8E0122",
  ruby700: "#B90230",
  ruby600: "#E8013E",
  ruby500: "#FF5664",
  ruby400: "#FF8386",
  ruby300: "#FCB3B2",
  ruby200: "#FBD3D2",
  ruby100: "#FBEEEE",
  ruby50: "#FCF7F7",
  white: "#FFFFFF",
  black: "#000000"
}, a = {
  brand1000: r.blurple1000,
  brand900: r.blurple900,
  brand800: r.blurple800,
  brand700: r.blurple700,
  brand600: r.blurple600,
  brand500: r.blurple500,
  brand400: r.blurple400,
  brand300: r.blurple300,
  brand200: r.blurple200,
  brand100: r.blurple100,
  brand50: r.blurple50
}, l = {
  unitQuarter: 2,
  unitHalf: 4,
  unit1: 8,
  unit2: 16,
  unit3: 24,
  unit4: 32,
  unit5: 40,
  unit6: 48,
  unit7: 56,
  unit8: 64,
  unit9: 72,
  unit10: 80,
  unit15: 120
}, s = {
  space: {
    xsmall: l.unitHalf,
    small: l.unit1,
    medium: l.unit2,
    large: l.unit3,
    xlarge: l.unit4,
    xxlarge: l.unit5
  },
  gutters: {
    wide: null,
    medium: null,
    narrow: null,
    internalPadding: null
  },
  breakpoints: {
    desktop: {
      wide: 1400,
      medium: 1280,
      small: 1024
    },
    mobile: {
      tablet: 768,
      phone: 320
    }
  },
  /** Maximum content width for page containers (1200px) */
  maxContentWidth: 1200,
  /** Maximum width for description/body text (600px) */
  maxTextWidth: 600
}, F = {
  baseFont: '"DM Sans",-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif',
  monoFont: '"DM Mono",ui-monospace,monospace',
  baseFontSize: 16,
  fontSize: {
    displayXLarge: "5rem",
    displayLarge: "4.5rem",
    displayMedium: "4rem",
    displaySmall: "3.5rem",
    displayXSmall: "2.5rem",
    displayXXSmall: "2rem",
    h1: "2rem",
    h2: "1.5rem",
    h3: "1.25rem",
    h4: "1rem",
    h5: "0.875rem",
    h6: "0.75rem",
    bodyXLarge: "1.5rem",
    bodyLarge: "1.25rem",
    bodyDefault: "1rem",
    bodySmall: "0.875rem",
    bodyXSmall: "0.75rem"
  },
  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700
  },
  lineHeight: {
    displayXLarge: 1.2,
    displayLarge: 1.11111111111111,
    displayMedium: 1.125,
    displaySmall: 1.14285714285714,
    displayXSmall: 1.2,
    displayXXSmall: 1.33333333333333,
    h1: 1.5,
    h2: 1.33333333333333,
    h3: 1.2,
    h4: 1.25,
    h5: 1.14285714285714,
    h6: 1.33333333333333,
    bodyXLarge: 1.33333333333333,
    bodyLarge: 1.2,
    bodyDefault: 1.5,
    bodySmall: 1.42857142857143,
    bodyXSmall: 1.66666666666667
  }
}, e = {
  colors: { ...r, ...a },
  layout: s,
  units: l,
  typography: F
}, o = {
  primaryIdle: e.colors.blurple700,
  primaryHover: e.colors.blurple900,
  primaryDisabled: e.colors.blurple800,
  secondaryIdle: e.colors.white,
  secondaryHover: e.colors.blurple100
}, n = {
  foreground: {
    primary: e.colors.black,
    secondary: e.colors.gray800,
    tertiary: e.colors.gray700,
    disabled: e.colors.gray700,
    action: e.colors.blurple700,
    actionSmall: e.colors.blurple900,
    successSmall: e.colors.green700,
    successLarge: e.colors.green600,
    errorSmall: e.colors.red700,
    errorLarge: e.colors.red600,
    inProgressSmall: e.colors.purple600,
    inProgressLarge: e.colors.purple500,
    warningLarge: e.colors.yellow500,
    warningSmall: e.colors.yellow700,
    brandLarge: e.colors.blurple700,
    brandSmall: e.colors.blurple700,
    infoLarge: e.colors.blurple700,
    infoSmall: e.colors.blurple700
  },
  background: {
    primary: e.colors.white,
    secondary: e.colors.gray50,
    tertiary: e.colors.gray100,
    disabled: e.colors.gray200,
    actionLight: e.colors.blurple100,
    actionMedium: e.colors.blurple700,
    actionHeavy: e.colors.blurple800,
    successDark: e.colors.green700,
    successLight: e.colors.green50,
    errorDark: e.colors.red700,
    errorMedium: e.colors.red500,
    errorLight: e.colors.red50,
    warningDark: e.colors.yellow700,
    warningMedium: e.colors.yellow400,
    warningLight: e.colors.yellow50,
    inProgressDark: e.colors.purple700,
    inProgressMedium: e.colors.purple600,
    inProgressLight: e.colors.purple50,
    neutralDark: e.colors.gray500,
    neutralLight: e.colors.gray300,
    brandDark: e.colors.blurple700,
    brandMedium: e.colors.blurple600,
    brandLight: e.colors.blurple100,
    infoDark: e.colors.blurple700,
    infoMedium: e.colors.blurple600,
    infoLight: e.colors.blurple100
  },
  callToAction: {
    primaryActionDark: e.colors.blurple900,
    primaryActionMedium: e.colors.blurple800,
    primaryActionLight: e.colors.blurple100
  },
  interaction: {
    focus: e.colors.blurple700,
    hoverLight: e.colors.gray100,
    hoverHeavy: e.colors.gray200,
    secondaryHover: o.secondaryHover,
    selectionLight: e.colors.blurple100,
    selectionHeavy: e.colors.blurple700
  },
  border: {
    primary: e.colors.gray200,
    secondary: e.colors.gray300,
    tertiary: e.colors.gray400,
    brand: e.colors.blurple200,
    error: e.colors.red200,
    warning: e.colors.terracotta200,
    success: e.colors.green200,
    inProgress: e.colors.purple200,
    info: e.colors.blurple200
  },
  dataVisualization: {
    sequence100: e.colors.blurple500,
    sequence150: e.colors.terracotta500,
    sequence200: e.colors.purple600,
    sequence250: e.colors.turquoise500,
    sequence300: e.colors.magenta500,
    sequence350: e.colors.blue600,
    sequence400: e.colors.red600,
    sequence450: e.colors.violet500,
    sequence500: e.colors.green500,
    sequence550: e.colors.yellow500,
    sequence600: e.colors.blurple600,
    sequence650: e.colors.orange600,
    sequence700: e.colors.purple500,
    sequence750: e.colors.turquoise600,
    sequence800: e.colors.magenta700,
    sequence850: e.colors.blue700,
    sequence900: e.colors.orange500,
    sequence950: e.colors.violet600,
    sequence1000: e.colors.green600,
    sequence1050: e.colors.yellow600
  },
  highlights: {
    purpleLight: e.colors.purple300,
    purpleDark: e.colors.violet600,
    salmonLight: e.colors.port200,
    salmonDark: e.colors.ruby500,
    indigoLight: e.colors.indigo200,
    indigoDark: e.colors.blurple900,
    tealLight: e.colors.jade300,
    tealDark: e.colors.cerulean600,
    terracottaLight: e.colors.terracotta300,
    terracottaDark: e.colors.terracotta600
  }
}, t = {
  /** Small component height: 32px - Use for dense toolbars and compact UIs */
  small: 32,
  /** Medium component height: 38px - Default size for most interfaces */
  medium: 38,
  /** Large component height: 44px - Use for primary actions and touch targets */
  large: 44,
  /** XLarge component height: 56px - Use for data grid rows and column headers */
  xLarge: 56
}, i = {
  /** Font size for small interactive components: 14px */
  small: "0.875rem",
  /** Font size for medium interactive components: 16px */
  medium: "1rem",
  /** Font size for large interactive components: 18px */
  large: "1.125rem"
}, u = {
  foundations: e,
  componentColors: o,
  semanticColors: n,
  componentSizes: t,
  componentFontSizes: i
};
export {
  u as capitalDesignTokens
};
